


/**
 * Fetch lens data from a base URL, appending an id as a query parameter
 * and including an Authorization header.
 *
 * @param {string} baseUrl - The base URL to call (e.g. https://api.example.com/lens)
 * @param {string} id - The id string to append as a query parameter named `id`
 * @param {string} authToken - Bearer token to include in the Authorization header
 * @param {object} [options] - Optional fetch options (method, body, etc.)
 * @returns {Promise<any>} Parsed JSON response
 */
export async function getLensData(baseUrl, id, authToken, options = {}) {
    if (!baseUrl) throw new Error('baseUrl is required');
    if (!id) throw new Error('id is required');

    // Build URL and append id parameter
    const url = new URL(baseUrl, window.location.origin);
    // If caller already passed query params, preserve them and add/override id
    url.searchParams.set('productID', id);

    console.log('Fetching lens data from:', url.toString());

    const headers = new Headers(options.headers || {});
    if (authToken) {
        headers.set('x-auth-key', authToken);
    }
    headers.set('Accept', 'application/json');

    const fetchOptions = {
        method: options.method || 'GET',
        headers,
        // Only include body for non-GET methods if provided
        ...(options.method && options.method.toUpperCase() !== 'GET' && options.body ? { body: options.body } : {}),
        // allow caller to override any of the above
        ...options.override,
    };

    const response = await fetch(url.toString(), fetchOptions);
    if (!response.ok) {
        const text = await response.text().catch(() => '');
        const err = new Error(`Request failed with status ${response.status}: ${response.statusText}`);
        err.status = response.status;
        err.body = text;
        throw err;
    }

    // Try to parse JSON, fall back to text
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        return response.json();
    }
    return response.text();
}